import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';
import { web3Api } from 'store/web3Api';

import { getBtcProvider, TBtcWalletId } from 'modules/api';

export const {
  useDisconnectBtcMutation,
  endpoints: { disconnectBtc },
} = web3Api.injectEndpoints({
  endpoints: build => ({
    disconnectBtc: build.mutation<null, TBtcWalletId>({
      queryFn: queryFnNotifyWrapper<TBtcWalletId, never, null>(
        async providerId => {
          const provider = await getBtcProvider(providerId);
          provider.disconnect();

          return { data: null };
        },
      ),
    }),
  }),
});
